<div class="auth-wrapper">
  <div class="auth-card">
    <div class="auth-card__header">
      <strong>ACTIVATE ACCOUNT</strong>
    </div>

    <div class="form-container">
      <div class="activation-panel">
        <div class="activation-panel__header">
          <h2>Activate your account</h2>
        </div>

        @if (loading) {
          <div class="muted">Loading activation details…</div>
        }

        @if (!loading && error) {
          <div class="alert error">
            {{ errorMessage }}
          </div>
        }

        @if (!loading && !success && !error) {
          <form
            [formGroup]="activationForm"
            (ngSubmit)="onSubmit()"
            >
            <input type="hidden" formControlName="action" />
            @if (manualMode) {
              <div class="form-group">
                <label for="email">Email</label>
                <input
                  id="email"
                  type="email"
                  formControlName="email"
                  autocomplete="email"
                  />
                @if (
                  activationForm.get('email')?.invalid &&
                  activationForm.get('email')?.touched
                  ) {
                  <span
                    class="validation-error"
                    >
                    Please enter a valid email address.
                  </span>
                }
              </div>
              <div class="form-group">
                <label for="oneTimeCode">One-time code</label>
                <input
                  id="oneTimeCode"
                  type="text"
                  formControlName="oneTimeCode"
                  autocomplete="one-time-code"
                  />
                @if (
                  activationForm.get('oneTimeCode')?.invalid &&
                  activationForm.get('oneTimeCode')?.touched
                  ) {
                  <span
                    class="validation-error"
                    >
                    One-time code is required.
                  </span>
                }
              </div>
            } @else {
              <input type="hidden" formControlName="email" />
              <input type="hidden" formControlName="oneTimeCode" />
              <div class="readonly-details">
                <div>
                  <span>Email</span>
                  <strong>{{ activationForm.get("email")?.value }}</strong>
                </div>
                <div>
                  <span>Activation code</span>
                  <strong>{{ activationForm.get("oneTimeCode")?.value }}</strong>
                </div>
              </div>
            }
            <button
              type="submit"
              class="btn-primary"
              [disabled]="submitting || activationForm.invalid"
              >
              {{ submitting ? "Activating…" : "Activate account" }}
            </button>
          </form>
        }

        @if (!loading && success) {
          <div class="alert success">
            <p>Your account has been activated!</p>
            <button class="btn-primary" type="button" (click)="navigateToLogin()">
              Log in
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
